<script>
export default {
  name: "AnalyticsDetailRow",
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      required: true,
    },
    showViewButton: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      required: false
    },
    tooltip: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    }
  },
  methods: {
    onView() {
      this.$emit("onView");
    }
  }
}
</script>

<template>
  <v-row class="py-2">
    <v-col :cols="showViewButton ? 8 : 9">
      <v-row class="ma-auto pa-0 justify-start" >
        <v-col cols="1" v-if="icon" class="ma-0 pa-0">
          <img

              :src="require(`@/assets/icons/${icon}`)"
              width="22"
              height="22"
              contain
              class="mr-0 pa-0"
          />
        </v-col>

        <span>{{ title }}</span>
        <v-tooltip v-if="tooltip" bottom max-width="500">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" class="ml-5" size="18" color="#96A4B9">
              mdi-information-outline
            </v-icon>
          </template>
          <span>{{tooltip}}</span>
        </v-tooltip>
      </v-row>
      <span class="reduce-line-height" >{{ subtitle }}</span>

    </v-col>
    <v-col :cols="showViewButton ? 2 : 3">
      <span>{{ value }}</span>
    </v-col>
    <v-col v-if="showViewButton" cols="2" class="view-button-padding">
      <div class="text-body-1 d-inline-block primary--text" @click="onView">
        View
      </div>
    </v-col>
  </v-row>
</template>

<style scoped>
.view-button-padding {
  padding-left: 1vw;
}

.reduce-line-height {
  line-height: 1px;
  color: #96A4B9;
}
</style>